<template>
  <div>
    <p class="float-right needHelp d-none">
      {{$t('route.NeedHelp')}}
      <img
        src="../assets/images/help.svg"
        alt="help"
        class="float-right ml-2"
      />
    </p>
  </div>
</template>
<script>
export default {
  name: 'Footer'
};
</script>
<style scoped lang="scss">
@import '../assets/scss/main.scss';
//  p
//  {
//   font-size: 13px;
//   color: #969696;
//  }
//  .footer
//  {
//      position: absolute;
//      bottom: -10px;
//  }
.needHelp {
  color: #969696 !important;
}
</style>



// WEBPACK FOOTER //
// src/components/Footer.vue